import { useEffect, useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function DemoAccess() {
  const [params] = useSearchParams();
  const { refresh } = useAuth();
  const nav = useNavigate();
  const [err, setErr] = useState("");
  useEffect(() => {
    localStorage.removeItem("company_id");
    api.post("/auth/demo-login", { token: params.get("token") || "" })
      .then(async () => { await refresh(); nav("/", { replace: true }); })
      .catch((e) => setErr(errMsg(e)));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <div className="min-h-screen grid place-items-center bg-[#09090B] p-6 text-white" data-testid="demo-access-page">
      <div className="text-center space-y-4 max-w-sm">
        <div className="inline-block bg-white rounded-xl px-4 py-3"><img src="/nolium-logo-full.png" alt="NOLIUM" className="h-10 w-auto" /></div>
        {err ? <><div className="text-sm text-red-300" data-testid="demo-error">{err}</div><Link to="/login" className="text-sm text-[#11A9A2] hover:underline">Vai all'accesso</Link></>
          : <div className="flex items-center gap-2 justify-center text-zinc-300"><Loader2 className="animate-spin" size={18} />Accesso alla demo NOLIUM…</div>}
      </div>
    </div>
  );
}
